module.exports = __webpack_public_path__ + "img/select-icon.4c3ca251.svg";